module.exports = __webpack_public_path__ + "static/media/3.ed692354.svg";